import type { Interceptor } from '@connectrpc/connect'
import { getToken } from './fetch-rpc'

/**
 * Authentication interceptor for connect-web transports.
 * Automatically fetches and adds the Authorization header to all RPC requests.
 */
export const authInterceptor: Interceptor = next => async req => {
  const token = await getToken()
  if (token) {
    req.header.set('Authorization', `Bearer ${token}`)
  }
  return next(req)
}
